import { onboarding } from '@services';
import Onboarding, {
  IOnboardingFile,
  IOnboardingFileApi,
} from '@models/Onboarding.model';

interface IRequest {
  studioId: string;
  fileId: string;
}

const getFileByFileId = async ({
  studioId,
  fileId,
}: IRequest): Promise<IOnboardingFile> => {
  const { data: file } = await onboarding.get<IOnboardingFileApi>(
    `/api/v1/file?studioId=${studioId}&fileId=${fileId}`,
  );

  return Onboarding.fromApiModel(file);
};

export { getFileByFileId };
